#import "@/components/common/CraftAssetFragment.gql"

fragment ParallaxImagesFragment on parallaxImages_Entry {
  typeHandle
  heading
  firstImageVideo {
    ...CraftAssetFragment
  }
  secondImageVideo {
    ...CraftAssetFragment
  }
  thirdImageVideo {
    ...CraftAssetFragment
  }
  overlayHeading
  overlayText
}
